// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PopupTemplateFirst_wrapper__2Yxz8","box":"PopupTemplateFirst_box__1_HIV","box2":"PopupTemplateFirst_box2__2AVGb","button":"PopupTemplateFirst_button__3AP4L"};